import { render, staticRenderFns } from "./MonCompte.vue?vue&type=template&id=bb6fdd04"
import script from "./MonCompte.vue?vue&type=script&lang=js"
export * from "./MonCompte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports